"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "watchAction", {
    enumerable: true,
    get: function() {
        return watchAction;
    }
});
const _createTargetGraph = require("./createTargetGraph.js");
const _filterArgsForTasks = require("./filterArgsForTasks.js");
const _config = require("@lage-run/config");
const _workspacetools = require("workspace-tools");
const _filterPipelineDefinitions = require("./filterPipelineDefinitions.js");
const _reporters = require("@lage-run/reporters");
const _scheduler = require("@lage-run/scheduler");
const _watcher = require("./watcher.js");
const _logger = /*#__PURE__*/ _interop_require_wildcard(require("@lage-run/logger"));
const _createCacheProvider = require("../../cache/createCacheProvider.js");
const _runnerPickerOptions = require("../../runnerPickerOptions.js");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
async function watchAction(options, command) {
    const cwd = process.cwd();
    const config = await (0, _config.getConfig)(cwd);
    const concurrency = (0, _config.getConcurrency)(options.concurrency, config.concurrency);
    // Configure logger
    const logger = (0, _logger.default)();
    const reporter = new _reporters.LogReporter({
        logLevel: _logger.LogLevel[options.logLevel]
    });
    logger.addReporter(reporter);
    // Build Target Graph
    const root = (0, _workspacetools.getWorkspaceRoot)(process.cwd());
    const packageInfos = await (0, _workspacetools.getPackageInfosAsync)(root);
    const { tasks, taskArgs } = (0, _filterArgsForTasks.filterArgsForTasks)(command.args);
    const targetGraph = await (0, _createTargetGraph.createTargetGraph)({
        logger,
        root,
        dependencies: options.dependencies,
        dependents: options.dependents && !options.to,
        ignore: options.ignore.concat(config.ignore),
        pipeline: config.pipeline,
        repoWideChanges: config.repoWideChanges,
        scope: (options.scope ?? []).concat(options.to ?? []),
        since: options.since,
        outputs: config.cacheOptions.outputGlob,
        tasks,
        packageInfos,
        priorities: config.priorities,
        enableTargetConfigMerging: config.enableTargetConfigMerging
    });
    // Make sure we do not attempt writeRemoteCache in watch mode
    config.cacheOptions.writeRemoteCache = false;
    const filteredPipeline = (0, _filterPipelineDefinitions.filterPipelineDefinitions)(targetGraph.targets.values(), config.pipeline);
    const maxWorkersPerTaskMap = (0, _config.getMaxWorkersPerTaskFromOptions)(options.maxWorkersPerTask);
    const { hasher } = await (0, _createCacheProvider.createCache)({
        root,
        logger,
        cacheOptions: config.cacheOptions,
        cliArgs: taskArgs,
        skipLocalCache: options.skipLocalCache
    });
    const scheduler = new _scheduler.SimpleScheduler({
        logger,
        concurrency,
        continueOnError: true,
        workerData: {
            root,
            taskArgs,
            skipLocalCache: options.skipLocalCache,
            cacheOptions: config.cacheOptions,
            runners: {
                ...(0, _runnerPickerOptions.runnerPickerOptions)(options.nodeArg, config.npmClient, taskArgs),
                ...config.runners
            }
        },
        shouldCache: options.cache,
        shouldResetCache: options.resetCache,
        maxWorkersPerTask: new Map([
            ...(0, _config.getMaxWorkersPerTask)(filteredPipeline, concurrency),
            ...maxWorkersPerTaskMap
        ]),
        hasher,
        workerIdleMemoryLimit: config.workerIdleMemoryLimit
    });
    // Initial run
    const summary = await scheduler.run(root, targetGraph);
    displaySummary(summary, logger.reporters);
    logger.info("Running scheduler in watch mode");
    // Disables cache for subsequent runs
    // TODO: support updating hasher + write-only local cacheProvider for subsequent runs
    for (const targetRun of scheduler.targetRuns.values()){
        targetRun.options.shouldCache = false;
    }
    // When initial run is done, disable fetching of caches on all targets, keep writing to the cache
    const watcher = await (0, _watcher.watch)(root, packageInfos);
    watcher.on("change", async (packageName)=>{
        reporter.resetLogEntries();
        const targets = new Map();
        for (const target of targetGraph.targets.values()){
            if (target.packageName === packageName) {
                targets.set(target.id, target);
            }
        }
        const deltaGraph = {
            targets
        };
        const summary = await scheduler.run(root, deltaGraph, true);
        displaySummary(summary, logger.reporters);
    });
}
function displaySummary(summary, reporters) {
    for (const reporter of reporters){
        reporter.summarize(summary);
        reporter.cleanup?.();
    }
}
